import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { AppLayout } from '@/components/layout/AppLayout';

/**
 * Pathless layout route that gates every authenticated page. If the user is
 * unauthenticated when they try to load any of these routes, we redirect to
 * `/sign-in` and remember where they were going so we can bounce them back
 * after login.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (context.authStatus === 'unauthenticated') {
      throw redirect({
        to: '/sign-in',
        search: { redirect: location.href },
      });
    }
  },
  component: AppLayoutRoute,
});

function AppLayoutRoute() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
